import React from 'react';
import Progress from '@cld/progress';
import { StyleSpinnerContainer } from '../App.styled';

export const Loader = () => {
    return (
        <StyleSpinnerContainer>
            <Progress.Circular size='xl' variant='secondary'/>
        </StyleSpinnerContainer>
    );
};
